var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "17px",
    viewBox: "0 0 9 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6B394EFB-0489-4729-A26C-4F79ADD6349A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.37267029,11.5010815 L4.62931892,7.75772998 C4.43926486,7.56767592 4.43926486,7.2595678 4.62931892,7.06951374 C4.81872433,6.87945968 5.12683244,6.87945968 5.31688649,7.06951374 L7.8861838,9.63881113 L7.8861838,0.5 L8.85915678,0.5 L8.85915678,9.63881113 L11.4284541,7.06951374 C11.6185081,6.87945968 11.9266163,6.87945968 12.1160217,7.06951374 C12.3060757,7.2595678 12.3060757,7.56767592 12.1160217,7.75772998 L8.37267029,11.5010815 Z M4,16.0818378 L4,15.1088648 L12.7450809,15.1088648 L12.7450809,16.0818378 L4,16.0818378 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5_Trade-Details-CFTC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CFTC-Trade-Details",
    transform: "translate(-1292.000000, -132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CFTC-/-Trade-Details-Header",
    transform: "translate(0.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trade-Details-Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Failed-Trade-Records-/-Download-.csv-button",
    transform: "translate(1152.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download-.csv-button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/Download",
    transform: "translate(136.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Download",
    fill: "#333333",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-\\uD83C\\uDFA8Color",
    mask: "url(#mask-2)",
    fill: "#DF2806"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "#DF2806-Swatch",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSmall);
export default __webpack_public_path__ + "static/media/download-small.e9325fa2cfe19e5934ccb70fede91256.svg";
export { ForwardRef as ReactComponent };